<template>
  <div v-if="asAnswer">
    {{ researchItem.answer.value }}
  </div>
  <input
    v-else
    class="form-control form-control-lg bg-lightest p-3"
    v-model="researchItem.answer.value"
    :id="itemId"
    ref="item"
  />
</template>

<script>
import { GenericItemMixin } from '@/reviewer/mixins';

export default {
  name: 'ItemTextInput',
  mixins: [
    GenericItemMixin,
  ],
  computed: {
    itemId() {
      return this.idPrefix ? `${this.idPrefix}-item-text-input` : 'item-text-input';
    },
  },
  mounted() {
    if (this.$refs.item) {
      this.$refs.item.focus();
    }
  },
};
</script>
